// extracted by mini-css-extract-plugin
export var button = "Search-module--button--ug0Sq";
export var buttonBase = "Search-module--buttonBase--CVVfo";
export var close = "Search-module--close--gBMc1";
export var fixedPanel = "Search-module--fixedPanel--jfDoI";
export var icon = "Search-module--icon--yXrHe";
export var inputField = "Search-module--inputField--kgb20";
export var link = "Search-module--link--MZNoM";
export var panel = "Search-module--panel--hooA2";
export var searchButton = "Search-module--searchButton--w5T0Y";